#!/usr/bin/env node
// artifact-analyzer CLI entry point (bin). Delegates to the commander program in
// ./cli/index.ts and sets the process exit code from the resolved exit code.

import { run } from "./cli/index.js";

run(process.argv.slice(2))
  .then((code) => {
    process.exitCode = code;
  })
  .catch((error: unknown) => {
    process.stderr.write(`Fatal: ${(error as Error).message}\n`);
    process.exitCode = 1;
  });
